import React from 'react';
import './About.css'
// import about_img from '../../assets/about.png';
// import play_icon from '../../assets/play-icon.png';
// import picture1 from '../../Assets/frontend_assets/Spices_Image.jpg'

const About = () => {
    return (
        <div className='about'>
            <div className="about-left">
                {/* <img src={picture1} alt="" className='about-img' /> */}
            </div>
            <div className="about-right">
                <h3>Spice for Soul®</h3>
                <h2>Hand picked Spices from god's own country</h2>
                <p>Welcome to Spice for Soul, your gateway to the authentic and diverse world of spice exports. As a trusted exporter based in Kerala, the heart of spice cultivation, we take pride in presenting an extensive range of premium spices. From the warm and aromatic cloves to the bold kick of pepper and the subtle allure of white pepper, our collection embodies the rich flavors that Kerala is renowned for. </p>
                <p>Explore the enchanting fragrance of cardamom, the zesty warmth of ginger, and an array of spice extracts that encapsulate the essence of culinary artistry.
                    Beyond spices, we bring you the pure essence of coconut oil, an integral part of Kerala’s traditional cuisine. </p>
                <p>Our commitment extends to providing quality rice, ensuring that each grain narrates the story of our fertile soils. Dive into a world of culinary excellence with our array of oils, including mustard oil, ginger oil, and groundnut oil, each carefully crafted to elevate your cooking experience.At Spice for Soul, we meticulously source, process, and export these treasures, maintaining the highest standards of authenticity and purity. Join us on a journey where every spice tells a tale, and every drop of oil echoes the essence of our vibrant culture. Experience the richness of Kerala’s bounty through our spice exports, where quality meets tradition.</p>
            </div>
        </div >
    )
}

export default About
